import { initializeApp } from "firebase/app";
import { getFirestore,doc,getDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAIYgVk6qia8R3Pu35n5na1GRWrL_aMI2U",
  authDomain: "my-portfolio-a1a34.firebaseapp.com",
  projectId: "my-portfolio-a1a34",
  storageBucket: "my-portfolio-a1a34.appspot.com",
  messagingSenderId: "499237505695",
  appId: "1:499237505695:web:3f357a93786817960f70aa",
  measurementId: "G-XYHX7J7GF9"
};


const app = initializeApp(firebaseConfig);
 export const db = getFirestore(app);